import { Component, EventEmitter, OnInit, Output } from '@angular/core'

@Component({
  selector: 'app-connect-tiket-wizard-complete',
  templateUrl: './connect-tiket-wizard-complete.component.html',
  styleUrls: ['./connect-tiket-wizard-complete.component.scss'],
})
export class ConnectTiketWizardCompleteComponent implements OnInit {
  @Output() reset = new EventEmitter()
  @Output() channel = new EventEmitter()
  @Output() done = new EventEmitter()
  constructor() {}

  ngOnInit(): void {}
}
